import Vue from 'vue';
import VueRouter from 'vue-router';

// Routes
import { isUserLoggedIn } from '@/auth/utils';
import { canNavigate } from '@/libs/acl/routeProtection';
import store from '@/store/index';

import fbrInvoice from './routes/fbr-invoice';

import uiElements from './routes/ui-elements/index';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', redirect: { name: 'auth-login' } },
    ...fbrInvoice,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();

  // Set browser title from route meta
  const browserTitle = to.meta.browserTitle || to.meta.pageTitle || 'FBR Invoice';
  document.title = browserTitle;

  const userData = JSON.parse(localStorage.getItem('userData'));

  // Handle login routes first to prevent infinite loops
  if (to.name === 'auth-login') {
    if (isLoggedIn) {
      // If already logged in, redirect to FBR dashboard
      return next({ name: 'dashboard' });
    } else {
      // Allow access to login page - bypass canNavigate check
      return next();
    }
  }

  // If not logged in and trying to access protected routes, redirect to login
  if (!isLoggedIn) {
    return next({ name: 'auth-login' });
  }

  // For FBR invoice routes, allow access for logged-in users
  if (to.path.startsWith('/apps/fbr-invoice')) {
    return next();
  }

  // For other routes, temporarily allow access to prevent infinite loops
  // The canNavigate function expects meta.action and meta.resource which FBR routes don't have
  return next();

  // Redirect if logged in
  // if (to.meta.redirectIfLoggedIn && isLoggedIn) {
  //   let firstRoute = Object.keys(store.state.user.authRoutes)[0];
  //   next({ name: firstRoute });
  // }

  return next();
});

/**
router.beforeEach((to, _, next) => {
  // Set browser title from route meta
  const browserTitle = to.meta.browserTitle || to.meta.pageTitle || 'Ibico';
  document.title = browserTitle;

  console.log('[ROUTE] ======================== ');
  console.log('[ROUTE] beforeEach()', { to, _ });

  const whiteList = ['ibico-dashboard', 'reports'];

  const isLoggedIn = !!isUserLoggedIn();
  console.log('[ROUTE] isLoggedIn', isLoggedIn);

  // Set browser title from route meta
  const browserTitle = to.meta.browserTitle || to.meta.pageTitle || 'Ibico';
  document.title = browserTitle;

  // If not logged in, redirect to login and the to route is login
  if ((!isLoggedIn && to.name === 'auth-login') || to.name === 'auth-login-v2') {
    console.log('[ROUTE] ======================== ');
    return next();
  }

  // If not logged in, redirect to login
  if (!isLoggedIn) {
    return next({ name: 'auth-login' });
  }

  if (whiteList.includes(to.name)) {
    return next();
  }

  // If logged in and trying to access login page, redirect to dashboard
  if (isLoggedIn && to.name === 'auth-login') {
    return next({ name: 'ibico-dashboard' });
  }

  const authRoutes = store.state.user.authRoutes;

  if (!!authRoutes && !!to.meta.authRoute && !(to.meta.authRoute in authRoutes)) {
    return next({ name: 'misc-not-authorized' });
  }

  // If authRoute is not in authRoutes, redirect to not authorized
  const authRoute = authRoutes[to.meta.authRoute];
  console.log('[ROUTE] authRoute', authRoute);

  if (!authRoute) {
    return next({ name: 'misc-not-authorized' });
  }

  if (
    !to.meta.permissionKey ||
    (to.meta.permissionKey in authRoute && !authRoute[to.meta.permissionKey])
  ) {
    return next({ name: 'misc-not-authorized' });
  }

  console.log('[ROUTE] ======================== ');
  return next();
});
 */

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
